export class debounce {
  protected static debouncedRequests = new Map();
  protected static clearCacheTimeouts = new Map();

  public static async debounceRequest(requestArgs, requestFn) {
    const cacheStr = JSON.stringify(requestArgs);
    if (!this.debouncedRequests.has(cacheStr)) {
      this.debouncedRequests.set(
        cacheStr,
        requestFn().then(
          (res) => {
            this.scheduleEviction(cacheStr);

            return res;
          },
          (err) => {
            // Evict a failure immediately. Debouncing exists to collapse
            // concurrent duplicate requests, and there is no value in handing a
            // later caller a cached error -- while leaving the entry in place
            // is catastrophic: the map is a static that lives for the whole
            // page session, so one transient failure (a 500, a timeout, an
            // expired token, a bodyless 304) would permanently poison that
            // exact argument set and no HTTP request would ever be issued for
            // it again. Anything polling with stable args dies on first error.
            this.evict(cacheStr);

            throw err;
          }
        )
      );
    }

    return this.debouncedRequests.get(cacheStr);
  }

  protected static scheduleEviction(cacheStr: string) {
    this.clearCacheTimeouts.set(
      cacheStr,
      setTimeout(() => this.evict(cacheStr), 1000)
    );
  }

  protected static evict(cacheStr: string) {
    clearTimeout(this.clearCacheTimeouts.get(cacheStr));
    this.clearCacheTimeouts.delete(cacheStr);
    this.debouncedRequests.delete(cacheStr);
  }
}
